import { render } from "./sections.vue?vue&type=template&id=2d316037&scoped=true"
import script from "./sections.vue?vue&type=script&lang=js"
export * from "./sections.vue?vue&type=script&lang=js"

import "./sections.vue?vue&type=style&index=0&id=2d316037&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d316037"]])

export default __exports__